export default function Skeleton() {
  return <div className='homepage-container absolute left-0 top-0 h-[200px] w-full bg-white lg:h-[330px]' data-sentry-component="Skeleton" data-sentry-source-file="skeleton.tsx">
            <div className='flex h-full w-full items-center justify-between'>
                <div className='h-full w-[9.5%] animate-pulse rounded-l bg-gray-100'></div>
                <div className='h-full w-[77%] animate-pulse rounded bg-gray-100'></div>
                <div className='h-full w-[9.5%] animate-pulse rounded-r bg-gray-100'></div>
            </div>
        </div>;
}